"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = exports.PaymentType = exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Swish"] = "swish";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["Request"] = "request";
    PaymentType["Payout"] = "payout";
    PaymentType["Refund"] = "refund";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Created"] = "created";
    PaymentStatus["Completed"] = "completed";
    PaymentStatus["Failed"] = "failed";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
